export let menus = [
    // {
    //     text: "基础设置",
    //     submenus: [
    //         {
    //             text: "库区管理",
    //             path: "/html-houselist"
    //         },
    //         {
    //             text: "货转方管理",
    //             path: "/html-purchaserlist"
    //         }
    //     ]
    // },
    // {
    //     text: "货转单管理",
    //     submenus: [
    //         {
    //             text: "货转单列表",
    //             path: "/html-forwardlist"
    //         },
    //         {
    //             text: "已过期货转单",
    //             path: "/html-forwardfinishlist"
    //         }
    //         // {
    //         //     text: "生成记录",
    //         //     path: "/forwardhistory"
    //         // }
    //     ]
    // },
    {
        text: "系统设置",
        submenus: [
            {
                text: "管理员列表",
                path: "/html-adminlist"
            },
            // {
            //     text: "盛虹数据",
            //     path: "/html-sh"
            // },
            // {
            //     text: "船报",
            //     path: "/html-ship-report-list"
            // },
        ]
    },
    {
        text: "店铺管理",
        submenus: [
            {
                text: "门店管理",
                path: "/html-store"
            },
            {
                text: "客户管理",
                path: "/html-user"
            },
            {
                text: "核销管理",
                path: "/html-value"
            },
            {
                text: "门店日常",
                path: "/html-daily"
            },
            {
                text: "报表",
                path: "/html-value-chart"
            },
        ]
    },
];
